import { render, staticRenderFns } from "./purHead.vue?vue&type=template&id=7dcdab14&scoped=true&"
import script from "./purHead.vue?vue&type=script&lang=js&"
export * from "./purHead.vue?vue&type=script&lang=js&"
import style0 from "./purHead.vue?vue&type=style&index=0&id=7dcdab14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcdab14",
  null
  
)

export default component.exports